module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-subscription-list row column"
  }, [(_vm.reports) ? _c('statistics-card4', [_c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('p', [_vm._v("Total Subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.total_subscriptions))])]), _c('div', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('p', [_vm._v("Expired Subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.expiring_subscriptions))])]), _c('div', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('p', [_vm._v("Renewed subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.renewed_subscriptions))])]), _c('div', {
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('p', [_vm._v("Renewed subscriptions Amount")]), _c('h2', [_vm._v(_vm._s(Math.ceil(_vm.reports.renewed_subscriptions_amount)) + _vm._s(_vm.currency))])])]) : _vm._e(), _c('subscription-list-form', {
    on: {
      "filterSubscriptions": _vm.setSearch
    }
  }), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  }, [_c('header-columns', {
    attrs: {
      "slot": "before",
      "columns": _vm.headers
    },
    slot: "before"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e645f030!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/SubscriptionList.vue
// module id = 2568
// module chunks = 1